const NO_FEE_OPTIONS = {
  value: 'no-option',
  label: 'Nothing available at the moment to cover the fee',
  paidBy: '',
  token: null,
  speedCoverage: []
}

export { NO_FEE_OPTIONS }
